<template>
    <div class="header">
        <img class="logo" src="/Images/PGProBlue.svg" @click="$emit('go-to-home')" />


        <div class="QOptions">
            <a
                class="howToVideosLink"
                href="https://protectionguru.co.uk/protection-guru-pro-how-to-videos/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <el-icon :size="16"><VideoPlay /></el-icon>
                <span>How to... Videos</span>
            </a>
            <div v-if="!isViewingAsOther && subscription !== null && subscription !== undefined && (subscription.subscriptionType === 'SingleUser' || subscription.subscriptionType === 'FirmAdmin')">
                <el-button :type="remainingCreditsType"
                           size="large"
                           v-loading="loading"
                           :round="true"
                           @click="SubscriptionService.getAdditionalCredits()">
                    <span style="font-size: 21px; font-weight: bold;">{{totalCredits}}</span>&nbsp;
                    <span style="font-weight:normal">Available {{totalCredits == 1 ? "Credit" : "Credits"}}</span>
                    &nbsp;<u style="font-weight:bold;">Add</u>
                </el-button>
            </div>

            <el-popover placement="bottom" width="200" trigger="click">
                <!-- View As section (feature-flagged by canShareAccount) -->
                <div v-if="userDetails?.canShareAccount && allViewableUsers.length > 0">
                    <el-link><strong>View as</strong></el-link>
                    <el-select
                        :model-value="selectedViewAsUserId"
                        @change="onViewAsChanged"
                        placeholder="Select user"
                        size="small"
                        style="width: 100%; margin-bottom: 8px;">
                        <el-option label="My account" :value="null" />
                        <el-option
                            v-for="user in allViewableUsers"
                            :key="user.userId"
                            :label="user.givenName + ' ' + user.surname"
                            :value="user.userId" />
                    </el-select>
                    <hr />
                </div>

                <template v-if="!isViewingAsOther">
                    <el-link v-if="userDetails?.canShareAccount" @click="visible = false" v-on:click.stop="$emit('manage-access')">
                        Manage access
                    </el-link>
                    <el-link v-if="subscription !== null && subscription !== undefined && userDetails !== null" @click="visible = false" v-on:click.stop="$emit('contact-us')">Contact
                        us</el-link>
                    <hr />
                    <span v-if="subscription !== null && subscription !== undefined && userDetails !== null && (userDetails.hasSetNoPricing || userDetails.integrations?.length > 0)">
                        <el-link>
                            <span style="font-weight:bold;">Settings</span>
                        </el-link>
                        <el-link @click="visible = false" v-on:click.stop="$emit('subscription-setting')">
                            Subscription Settings
                        </el-link>
                        <el-link @click="visible = false" v-on:click.stop="$emit('commission-setting')">
                            Commission settings
                        </el-link>
                        <el-link @click="visible = false" v-on:click.stop="$emit('price-setting')">
                            Price settings
                        </el-link>
                        <hr />
                    </span>
                </template>
                <div v-if="!!userDetails?.isAdminUser && !isViewingAsOther">
                    <el-link><strong>Admin</strong></el-link>
                    <el-link @click="$emit('config-products')">Configure Product Mappings</el-link>
                    <el-link @click="$emit('config-filters')">Configure Product Filters</el-link>
                    <el-link @click="$emit('popup-message')">Configure Popup Message</el-link>
                </div>
                <hr />
                <el-link v-on:click.stop="Logout()" style="font-weight:700">Logout</el-link>
                <template #reference>
                    <el-button type="primary" class="accountButton" style="height: 40px;" round>
                        <span v-if="isViewingAsOther">{{ viewAsDisplayName }} (viewing as)</span>
                        <span v-else>My account</span>
                        &nbsp;
                        <el-icon :size="16">
                            <User />
                        </el-icon>
                    </el-button>
                </template>
            </el-popover>
        </div>
    </div>
</template>
<style scoped>
button.el-button.el-button--customborder {
    border: 2px solid white;
    background: none;
    color: white;
}

.creditsButton {
    margin-right: 20px;
}

.accountButton.el-button.is-round,
.el-button.is-round {
    border-radius: 20px !important;
    padding: 12px 23px !important;
}

.logo {
    position: absolute;
    left: 114px;
    top: 0%;
    bottom: 43.3%;
    cursor: pointer;
    z-index: 5;
}

.header {
    background: #181F6A;
    position: fixed;
    width: 100%;
    height: 84px;
    left: 0px;
    top: 0px;
}

.QOptions {
    position: relative;
    height: 44px;
    top: 20px;
    font-family: 'Circular Std';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 12px;
    color: #FFFFFF;
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 16px;
    box-sizing: border-box;
}

hr {
    border-bottom: 1px solid #D8D8D8 !important;
}

.el-link {
    display: block;
}

.el-link.el-link--default:after {
    color: #0F172A !important;
}

.el-link.el-link--default {
    font-family: 'Inter' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 34px !important;
    color: #000A34 !important;
}

.el-link.is-underline:hover:after {
    border-bottom: none !important;
}

.el-link.el-link--default:hover {
    color: #0F172A !important;
}

.accountButton.el-button,
.accountButton.el-button--primary:focus,
.accountButton.el-button--primary:hover {
    font-family: 'Inter' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    border-radius: 46px !important;
    color: #fff !important;
    background: #353C8E !important;
    margin-left: unset;
    margin-right: unset;
    display: inline !important;
}

.accountButton.el-button:focus,
.accountButton.el-button:hover,
.accountButton.el-button--primary {
    color: #FFFFFF;
    border-color: #353C8E !important;
    background-color: #353C8E !important;
    margin-left: unset;
    margin-right: unset;
    display: inline;
}

.howToVideosLink {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #FFFFFF;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
    padding: 12px 23px;
    box-sizing: border-box;
    border-radius: 20px;
    background: #49A267;
    transition: background 0.15s, box-shadow 0.15s;
    line-height: 20px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.howToVideosLink:hover,
.howToVideosLink:focus {
    background: #3F8E59;
    color: #FFFFFF;
    text-decoration: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}

.howToVideosLink .el-icon {
    flex-shrink: 0;
}
</style>
<script>
import { useViewAs } from '../composables/useViewAs';

export default {
    name: 'HeaderControl',
    props: ["userDetails", "currentScreen"],
    inject: ["SubscriptionService", "AccessService"],
    setup() {
        const { viewAsUser, isViewingAsOther, viewAsDisplayName, setViewAsUser, clearViewAs } = useViewAs()
        return { viewAsUser, isViewingAsOther, viewAsDisplayName, setViewAsUser, clearViewAs }
    },
    computed: {
        remainingCreditsType: function () {
            if (this.totalCredits === null)
                return null;
            if (this.totalCredits > 4)
                return "customborder"; /*green*/
            if (this.totalCredits > 2)
                return "warning"; /*amber*/
            return "danger"; /*red*/
        },
        totalCredits: function () {
            if (this.subscription === null) {
                return null;
            }
            return this.subscription.totalCredits;
        },
        allViewableUsers: function () {
            var list = this.AccessService.getGrantedToMe().value || []
            return list.map(function (g) {
                var nameParts = (g.adviserName || '').split(' ', 2)
                return { userId: g.adviserId, givenName: nameParts[0] || '', surname: nameParts.slice(1).join(' ') || '' }
            })
        },
        selectedViewAsUserId: function () {
            return this.viewAsUser?.userId || null
        }
    },
    data() {
        return {
            visible: false,
            subscription: null,
            loading: false
        };
    },
    mounted: function () {
        this.subscription = this.SubscriptionService.getSubscription();
        this.loading = this.SubscriptionService.isloading();

        // Fetch users who granted me access (only if feature is enabled)
        if (this.userDetails?.canShareAccount) {
            this.AccessService.fetchGrantedToMe()
        }
    },
    methods: {
        Logout: function () {
            this.clearViewAs()
            sessionStorage.clear();
            window.location = "/Api/signout";
        },
        onViewAsChanged: function (userId) {
            if (userId === null) {
                this.clearViewAs()
            } else {
                var user = this.allViewableUsers.find(u => u.userId === userId)
                if (user) {
                    this.setViewAsUser(user)
                }
            }
            // Show loading screen before reload
            sessionStorage.setItem('viewAsSwitching', 'true')
            var loadingEl = document.getElementById('app-loading')
            if (loadingEl) loadingEl.style.display = 'flex'
            window.location.href = '/'
        }
    }
}
</script>
